<section>
  <h1>{{ formTitle }}</h1>
  <form [formGroup]="resultForm" *ngIf="resultData">
    <p-tabView (onChange)="onTabChange($event)" styleClass="tabview-wizard" [tabindex]="-1" autofocus [(activeIndex)]="activeTabIndex">
      <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'20%'}">
        <ng-template pTemplate="header">
          <span class="round-tabs">
            <i class="fas fa-edit fa-md" aria-hidden="true"></i>
          </span>
          <span class="round-tabs-label">General Information</span>
        </ng-template>
        <section>
          <h2>General Information</h2>
          <div class="mb-3">
            <label for="CreatedBy" class="form-label required-field">Created By:</label>
            <input type="text" readonly formControlName="CreatedBy" class="form-control w-lg-50" id="CreatedBy" />
          </div>
          <div class="mb-3">
            <label for="CGICCode" class="form-label required-field">Field Division</label>
            <select #fd id="CGICCode" formControlName="CGICCode" class="form-select w-lg-50" (change)="onChangeFD($event, fd.value)" required aria-required="true">
              <option value="">Select a field division</option>
              <ng-container *ngIf="fieldDivisions$ | async as fds">
                <option *ngFor="let fd of fds" value="{{fd.ENESS_REF_NIBINCGICCodes?.OrganizationCode}}">{{fd.FieldDivisionName}}</option>
              </ng-container>
            </select>
            <div class="invalid-feedback">
              Please select a field division.
            </div>
          </div>
          <div class="mb-3" *ngIf="!resultForm.get('CGICCode').invalid">
            <label for="CGICSupervisor_Id" class="form-label required-field">ATF CGIC Supervisor:</label>
            <select id="CGICSupervisor_Id" formControlName="CGICSupervisor_Id" class="form-select w-lg-50" required aria-required="true">
              <option value="">Select supervisor</option>
              <option *ngFor="let sup of resultData.AllCGICSupervisors" [value]="sup.Id">{{sup.LastName}}, {{sup.FirstName}} ({{sup.Email}})</option>
            </select>
            <div class="invalid-feedback">
              Please select the CGIC supervisor.
            </div>
          </div>
          <div class="mb-3">
            <label for="AlternateCGICApprover_Id" class="form-label">Alternate Results Approver:</label>
            <select id="AlternateCGICApprover_Id" formControlName="AlternateCGICApprover_Id" class="form-select w-lg-50">
              <option value="">Select alternate approver</option>
              <option *ngFor="let sup of resultData.AllCGICPersonnel" [value]="sup.Id">{{sup.LastName}}, {{sup.FirstName}} ({{sup.Email}})</option>
            </select>
          </div>
          <div class="mb-3">
            <label for="InvestigativeTrackingNumber" class="form-label">Results Tracking #:</label>
            <input type="text" readonly formControlName="InvestigativeTrackingNumber" class="form-control w-lg-50" id="InvestigativeTrackingNumber" />
          </div>
          <div class="mb-3 table-responsive w-lg-50">
            <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th scope="col">IR Tracking Numbers</th>
                  <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="ENESS_XREF_SuccessStoriesCIPs.controls.length == 0;else irnumrows"><tr><td colspan="2">No IR Tracking numbers found.</td></tr></ng-container>
                <ng-template #irnumrows>
                  <tr *ngFor="let cip of ENESS_XREF_SuccessStoriesCIPs.controls;let i = index">
                    <th scope="row">{{ cip.get('CIPTrackingID').value }}</th>
                    <td class="text-center"><button type="button" title="Delete IR tracking number" (click)="ENESS_XREF_SuccessStoriesCIPs.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete IR tracking number</span></button></td>
                  </tr>
                </ng-template>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="p-3">
                    <div class="mb-3">
                      <label class="form-label" for="CIPID">IR tracking number</label>
                      <p class="small">(Type first 3 digits of an IR tracking number for autocomplete search)</p>
                      <p-autoComplete #irtn inputId="CIPID" inputStyleClass="form-control" [suggestions]="irTrackingNumbers" field="CIPTrackingID" [minLength]="3" (completeMethod)="searchIRTrackingNumbers($event)" [tabindex]="0" appendTo="body"></p-autoComplete>
                    </div>
                    <button type="button" id="addCIP" class="btn btn-sm btn-success" [disabled]="!irtn.value" (click)="onAddIRTrackingNumber($event, irtn)"><i class="fa fa-plus" aria-hidden="true"></i> Add IR tracking number</button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="row row-cols-md-2 g-3 align-items-start">
            <div class="col-12 mb-3 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered ">
                <caption class="caption-top form-label text-body">Primary Crime Gun ID(s)</caption>
                <thead>
                  <tr>
                    <th scope="col">Crime Gun ID(s)</th>
                    <th scope="col">Legacy Gun ID(s)</th>
                    <th scope="col"><i pTooltip="# of shootings linked to the Primary Crime Gun ID" class="fas fa-info-circle fa-md ms-3" aria-hidden="true"></i> # of Linked Shootings </th>
                    <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="ENESS_XREF_SuccessStoriesCrimeGuns_Primary.controls.length == 0;else pcgrows"><tr><td colspan="4">No primary crime gun ID(s) found.</td></tr></ng-container>
                  <ng-template #pcgrows>
                    <tr *ngFor="let cgn of ENESS_XREF_SuccessStoriesCrimeGuns_Primary.controls;let i = index">
                      <th scope="row">{{ cgn.get('CrimeGunNumber').value }}</th>
                      <td>{{ cgn.get('ENESS_CrimeGunNumbers.LegacyATFGunNumber')?.value }}</td>
                      <td>{{ cgn.get('NumberOfLinkedShootings').value }}</td>
                      <td class="text-center">
                        <button type="button" title="Delete crime gun ID" (click)="ENESS_XREF_SuccessStoriesCrimeGuns_Primary.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete crime gun ID</span></button>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="p-3">
                      <div class="mb-3">
                        <label class="form-label" for="PrimaryCrimeGunNumberID">Primary Crime Gun ID(s)</label>
                        <p class="small">(Type first 6 digits of a crime gun ID for autocomplete search, i.e. 760-18)</p>
                        <p-autoComplete #pcgn inputId="PrimaryCrimeGunNumberID" inputStyleClass="form-control" [suggestions]="crimeGunNumbers" field="CrimeGunNumber" [minLength]="6" (completeMethod)="searchCrimeGunNumbers($event)" [tabindex]="0" appendTo="body"></p-autoComplete>
                      </div>
                      <button type="button" id="addPrimaryCG" class="btn btn-sm btn-success" [disabled]="!pcgn.value" (click)="onAddPrimaryCrimeGunNumber($event, pcgn)"><i class="fa fa-plus" aria-hidden="true"></i> Add Primary Crime Gun ID(s)</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="col-12 mb-3 table-responsive">
              <table class="temp-bs table table-sm table-striped table-bordered ">
                <caption class="caption-top form-label text-body">Linked Crime Gun ID(s)</caption>
                <thead>
                  <tr>
                    <th scope="col">Crime Gun ID(s)</th>
                    <th scope="col">Legacy Gun ID(s)</th>
                    <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="ENESS_XREF_SuccessStoriesCrimeGuns_Related.controls.length == 0;else lcgrows"><tr><td colspan="3">No linked crime gun ID(s) found.</td></tr></ng-container>
                  <ng-template #lcgrows>
                    <tr *ngFor="let cgn of ENESS_XREF_SuccessStoriesCrimeGuns_Related.controls;let i = index">
                      <th scope="row">{{ cgn.get('CrimeGunNumber').value }}</th>
                      <th scope="row">{{ cgn.get('ENESS_CrimeGunNumbers.LegacyATFGunNumber')?.value }}</th>
                      <td class="text-center">
                        <button type="button" title="Delete crime gun ID" (click)="ENESS_XREF_SuccessStoriesCrimeGuns_Related.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete crime gun ID</span></button>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3" class="p-3">
                      <div class="mb-3">
                        <label class="form-label" for="LinkedCrimeGunNumberID">Linked Crime Gun ID(s)</label>
                        <p class="small">(Type first 6 digits of a crime gun ID for autocomplete search, i.e. 760-18)</p>
                        <p-autoComplete #lcgn inputId="LinkedCrimeGunNumberID" inputStyleClass="form-control" [suggestions]="crimeGunNumbers" field="CrimeGunNumber" [minLength]="6" (completeMethod)="searchCrimeGunNumbers($event)" [tabindex]="0" appendTo="body"></p-autoComplete>
                      </div>
                      <button type="button" id="addPrimaryCG" class="btn btn-sm btn-success" [disabled]="!lcgn.value" (click)="onAddLinkedCrimeGunNumber($event, lcgn)"><i class="fa fa-plus" aria-hidden="true"></i> Add Linked Crime Gun ID(s)</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="mb-3 table-responsive">
            <table class="temp-bs table table-sm table-striped table-bordered ">
              <caption class="caption-top form-label text-body">RMS Event(s)</caption>
              <thead>
                <tr>
                  <th scope="col">State</th>
                  <th scope="col">Agency</th>
                  <th scope="col">LE Case #</th>
                  <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="ENESS_XREF_SuccessStoriesLECaseNumbers.controls.length == 0;else lcnrows"><tr><td colspan="4">No LE Case #(s) found.</td></tr></ng-container>
                <ng-template #lcnrows>
                  <tr *ngFor="let lecn of ENESS_XREF_SuccessStoriesLECaseNumbers.controls; let i = index">
                    <th scope="row">{{ lecn.value.ENESS_REF_State.StateAbbreviation}} </th>
                    <td>{{lecn.value.ENESS_REF_Agency.AgencyName }}</td>
                    <td>{{ lecn.value.LECaseNumber }}</td>
                    <td class="text-center"><button type="button" title="Delete LE case number" (click)="ENESS_XREF_SuccessStoriesLECaseNumbers.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete LE case number</span></button></td>
                  </tr>
                </ng-template>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4" class="p-3">
                    <div class="row row-cols-lg-auto gy-2 gx-3 align-items-start" [formGroup]="leCaseNumberForm">
                      <div class="col-12">
                        <label class="form-label" for="StateID">State</label>
                        <select #state id="StateID" formControlName="StateID" class="form-select" (change)="searchAgencies(state.value)">
                          <option value="">Select a state</option>
                          <ng-container *ngIf="lookupService.usStates$ | async as usStates">
                            <option *ngFor="let state of usStates" value="{{state.StateID}}">{{state.StateName}}</option>
                          </ng-container>
                        </select>
                      </div>
                      <div class="col-12">
                        <label class="form-label" for="AgencyID">Agency</label>
                        <select #agency id="AgencyID" formControlName="AgencyID" class="form-select" (change)="searchLECaseNumbers(agency.value)">
                          <option value="">Select an agency</option>
                          <option *ngFor="let agency of agenciesByStateId" value="{{agency.AgencyID}}">{{agency.AgencyName}}</option>
                        </select>
                      </div>
                      <div class="col-12">
                        <label for="LECaseNumberID" class="form-label">
                          LE Case #
                        </label>
                        <p-autoComplete #lcn inputId="LECaseNumberID" formControlName="LECaseNumberID" [suggestions]="caseNumbersTextFiltered" (completeMethod)="filterLECaseNumberSingle($event)" field="LECaseNumber" placeholder="Select a case #" inputStyleClass="form-select" [minLength]="1" [dropdown]="true" appendTo="body"></p-autoComplete>
                        <p class="small">(Begin typing to search)</p>
                        <div class="cross-validation-feedback" *ngIf="leCaseNumberForm.get('AgencyID').valid && caseNumbersByAgencyId.length == 0">
                          No case numbers found for selected agency
                        </div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-success mt-2" [disabled]="leCaseNumberForm.invalid" (click)="onAddLECaseNumber()"><i class="fa fa-plus" aria-hidden="true"></i> Add LE Case #</button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </section>
      </p-tabPanel>
      <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'20%'}">
        <ng-template pTemplate="header">
          <span class="round-tabs">
            <i class="fas fa-clipboard-list fa-md" aria-hidden="true"></i>
          </span>
          <span class="round-tabs-label">Narrative/Attachments</span>
        </ng-template>
        <section>
          <h2>Narrative/Attachments</h2>
          <div class="alert alert-info">
            <div class="row row-cols-lg-3 gy-2 gx-3 align-items-start">
              <div class="col-12">
                <fieldset class="mb-3">
                  <legend class="required-field form-label">NIBIN/CGI Contributed To:</legend>
                  <ng-container formArrayName="ENESS_XREF_SuccessStoriesFactors" *ngFor="let factor of resultData.SuccessStoriesFactors;let i = index">
                    <div class="form-check" [formGroupName]="i" [class.d-none]="factor.Deleted">
                      <input #factorChbx id="{{factor.SuccessStoriesFactorID}}" class="form-check-input" type="checkbox" formControlName="chbx" value="{{factor.SuccessStoriesFactorID}}">
                      <label class="form-check-label" for="{{factor.SuccessStoriesFactorID}}">{{factor.SuccessStoryFactor}}</label>
                    </div>
                  </ng-container>
                  <div class="cross-validation-feedback" *ngIf="resultForm.get('ENESS_XREF_SuccessStoriesFactors').touched && resultForm.get('ENESS_XREF_SuccessStoriesFactors').hasError('multipleCheckboxRequireOne')">
                    Please provide the success factor(s).
                  </div>
                </fieldset>
              </div>
              <div class="col-12">
                <fieldset class="mb-3">
                  <legend class="form-label">ATF Assets/Systems:</legend>
                  <ng-container formArrayName="ENESS_XREF_SuccessStoriesATFAssets" *ngFor="let asset of resultData.SuccessStoryATFAssets;let i = index">
                    <div class="form-check" [formGroupName]="i">
                      <input #assetChbx type="checkbox" id="{{asset.ATFAssetID}}" value="{{asset.ATFAsset}}" formControlName="chbx" class="form-check-input" />
                      <label class="form-check-label" for="{{asset.ATFAssetID}}">{{ asset.ATFAsset }}</label>
                    </div>
                  </ng-container>
                </fieldset>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="NumberOfShootings" class="required-field form-label"># of Shootings Linked to Arrestees/Defendants:</label>
                  <input id="NumberOfShootings" formControlName="NumberOfShootings" type="number" max="999" min="0" class="form-control" (change)="valueRangeCheck()" required aria-required="true" />
                  <div class="invalid-feedback">
                    Please provide the number of shootings.
                  </div>
                </div>
                <div class="mb-3">
                  <label for="NumberOfFirearmsRecovered" class="form-label required-field">Firearm(s) Recovered:</label>
                  <input id="NumberOfFirearmsRecovered" formControlName="NumberOfFirearmsRecovered" type="number" max="999" min="0" class="form-control" (change)="valueRangeCheck()" required aria-required="true" />
                  <div class="invalid-feedback">
                    Please provide the number of firearms recovered.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="Narrative" class="form-label required-field">Narrative:</label>
            <p class="font-size-sm fw-bold text-danger">This Result will be reviewed by your Field Division Leadership.  Upon their approval, it will be forwarded to ATF HQ similar to iNOTE and iNIBIN.</p>
            <p class="notes">
              Please summarize the circumstances surrounding the investigation and prosecution. Include a description of how the NIBIN/CGI factors and ATF assets/systems you selected contributed to the overall outcome.  If you are updating an existing narrative section, please add “UPDATE” at the end, followed by new info.
            </p>
            <textarea rows="15" formControlName="Narrative" id="Narrative" class="form-control" required aria-required="true"></textarea>
            <div class="cross-validation-feedback" *ngIf="resultData.ENESS_SuccessStory?.CurrentSuccessStoryStatus?.ENESS_REF_SuccessStoriesStatuses?.SuccessStoriesStatus !== 'Draft' && resultForm.get('Narrative').invalid">
              Please provide the narrative.
            </div>
          </div>
          <div class="mb-3">
            <label for="ResultAttachmentUpload" class="form-label">Attachments:</label>
            <div class="notes">
              Notes:
              <ol>
                <li><i>Total # of upload files allowed: {{ totalNumberOfUploadFilesAllowed }}</i></li>
                <li><i>Max size allowed per file: 5MB</i></li>
                <li><i>File types supported: PDF, JPG, PNG, TIFF, JPEG, ANB, DOC, DOCX, XLS, XLSX, PPT, PPTX, MSG</i></li>
              </ol>
            </div>
            <p-fileUpload #fileInput
                          url="{{apiRoot}}/api/Result/ResultAttachmentUpload"
                          [multiple]="true"
                          name="attachments[]"
                          [showUploadButton]="false"
                          [accept]="allowedFileTypes"
                          [maxFileSize]="maxFileSize"
                          [fileLimit]="totalNumberOfUploadFilesAllowed"
                          invalidFileSizeMessageSummary="{0}: Invalid file size."
                          invalidFileSizeMessageDetail="Maximum upload size is {0}. File was NOT uploaded."
                          invalidFileLimitMessageDetail="The number of files exceeds the maximum total file upload limit of {0}."
                          [headers]="fileUploadHeaders"
                          (onRemove)="onRemoveAttachment($event)"
                          (onSelect)="onSelectAttachment($event)"
                          (onUpload)="onFileUpload($event)"
                          (onError)="onUploadErrorHandler($event)"
                          styleClass="mb-3">
            </p-fileUpload>
            <a aria-hidden="true" class="d-none" download="" #downloadTemplateLink></a>
          </div>
          <p-table [value]="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesAttachments" styleClass="mb-3" [autoLayout]="true" [paginator]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" [rows]="rows" *ngIf="resultData.ENESS_SuccessStory.ENESS_XREF_SuccessStoriesAttachments.length > 0">
            <ng-template pTemplate="caption">
              <div class="p-2 fw-medium text-center">
                Uploaded attachments
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">File name</th>
                <th scope="col">Created by</th>
                <th scope="col">Created on</th>
                <th scope="col"><span class="visually-hidden">Remove</span></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2">
                  No uploaded attachments found.
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr>
                <th scope="row"><button type="button" class="btn btn-link" aria-label="Download attachment file" (click)="onClickDownload(rowData.ENESS_SuccessStoryAttachments)">{{rowData.ENESS_SuccessStoryAttachments?.FileName}}</button></th>
                <td>{{rowData.ENESS_SuccessStoryAttachments?.CreatedBy}}</td>
                <td>{{rowData.ENESS_SuccessStoryAttachments?.CreatedOn | date:'MM/dd/yyyy'}}</td>
                <td class="text-center w-10">
                  <button type="button" class="btn btn-sm btn-danger" aria-label="Remove attachment" (click)="deleteUploadedAttachment(rowIndex)"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove attachment</span></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      </p-tabPanel>
      <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'20%'}">
        <ng-template pTemplate="header">
          <span class="round-tabs">
            <i class="fas fa-user fa-md" aria-hidden="true"></i>
          </span>
          <span class="round-tabs-label">Defendant(s)</span>
        </ng-template>
        <section>
          <h2>Defendant(s)</h2>
          <div class="row row-cols-lg-auto g-3 align-items-center mb-3">
            <div id="radioGroupLabelNFORCE" class="required-field col-12">Are these results documented in an ATF NFORCE case?</div>
            <div class="col-12" role="radiogroup" aria-labelledby="radioGroupLabelNFORCE">
              <div *ngFor="let nf of resultData.SuccessStoryDefendantHasNFORCECaseNumbers" class="form-check form-check-inline">
                <input #nforcecase class="form-check-input" type="radio" name="HasNFORCECaseNumberID" formControlName="HasNFORCECaseNumberID" id="{{nf.HasNFORCECaseNumberValue}}" value="{{nf.HasNFORCECaseNumberID}}" (change)="onChangeHasNFORCECaseNumber(nforcecase.id)">
                <label class="form-check-label" for="{{nf.HasNFORCECaseNumberValue}}">{{nf.HasNFORCECaseNumberValue}}</label>
              </div>
            </div>
          </div>
          <div class="mb-3" [hidden]="hideNFORCECaseInput">
            <label for="NFORCECaseNumber" class="required-field form-label">NFORCE Case # (format: 999999-99-9999):</label>
            <p-inputMask formControlName="NFORCECaseNumber" typeof="text" mask="999999-99-9999" inputId="NFORCECaseNumber" styleClass="form-control w-auto" [required]="true" [ariaRequired]="true"></p-inputMask>
            <div class="invalid-feedback" *ngIf="resultForm.get('NFORCECaseNumber').invalid">
              Please provide the NFORCE case number.
            </div>
          </div>
          <p-table [value]="resultData.ENESS_SuccessStory?.ENESS_XREF_SuccessStoryDefendant" [paginator]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" [rows]="rows" [autoLayout]="true" selectionMode="single" [(selection)]="selectedDefendant">
            <ng-template pTemplate="caption">
              <div class="p-2 fw-bold text-center">Defendant(s) Selection</div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="LastName" scope="col">Last name <p-sortIcon field="LastName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
                <th pSortableColumn="FirstName" scope="col">First name <p-sortIcon field="FirstName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon></th>
                <th scope="col">Adjudication Status</th>
                <th scope="col">Prosecution Type</th>
                <th scope="col">Arrest Date</th>
                <th scope="col">Conviction Date </th>
                <th scope="col">Sentence Date</th>
                <th scope="col">Sentence (In Months)</th>
                <th scope="col"># Shootings Charged/Indicted</th>
                <th scope="col">Charge(s)</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="11">
                  No defendants found.
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr>
                <th scope="row">
                  <button type="button" class="btn btn-link" tabindex="0" aria-label="View defendant {{ rowData.ENESS_Person?.FirstName + ' ' + rowData.ENESS_Person?.LastName }}'s details" (click)="viewSelectedDefendant(rowData)">{{rowData.ENESS_Person?.LastName}}</button>
                </th>
                <td>{{ rowData.ENESS_Person?.FirstName }}</td>
                <td>{{ rowData.ENESS_REF_SuccessStoryAdjudicationStatuses?.SuccessStoryAdjudicationStatus }}</td>
                <td>{{ rowData.ENESS_REF_SuccessStoryProsecutionTypes?.SuccessStoryProsecutionType }}</td>
                <td>{{ rowData.ArrestDate | date:"MM/dd/yyyy" }}</td>
                <td>{{ rowData.ConvictionDate | date:"MM/dd/yyyy" }}</td>
                <td>{{ rowData.SentencingDate | date:"MM/dd/yyyy" }}</td>
                <td>{{ rowData.SentenceInMonths }}</td>
                <td>{{ rowData.NumberOfShootingsChargedOrIndicted }}</td>
                <td>{{ rowData.Charges }}</td>
                <td>
                  <button type="button" title="Delete defendant" (click)="resultData.ENESS_SuccessStory?.ENESS_XREF_SuccessStoryDefendant.splice(rowIndex, 1)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete defendant</span></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="cross-validation-feedback" *ngIf="ENESS_XREF_SuccessStoriesDefendants.invalid">
            One or more defendants is missing required adjudication status.
          </div>
          <div class="mt-3"><span class="notes-label-red">&nbsp;<b>Caveat:</b>&nbsp;</span> <span class="notes"> All defendants must <b>already</b> exist in NESS in order to be added as a defendant.</span></div>
          <button type="button" (click)="defForm._defendant = this.selectedDefendant = null; showSidebar = true;" class="btn btn-success mt-2">Add defendant</button>
        </section>
      </p-tabPanel>
      <p-tabPanel headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'20%'}">
        <ng-template pTemplate="header">
          <span class="round-tabs">
            <i class="fas fa-check fa-md" aria-hidden="true"></i>
          </span>
          <span class="round-tabs-label">Review</span>
        </ng-template>
        <section>
          <div class="d-flex justify-content-center">
            <div class="alert alert-light font-size-sm" role="alert">
              <i class="fas fa-info-circle fa-md" aria-hidden="true"></i> Click Previous or a Progress icon to edit the result before submission.
            </div>
          </div>
          <h2>Review</h2>
          <ness-result-notification [notification]="generalNotification" (reviewLinkClicked)="activateTab($event)"></ness-result-notification>
          <ness-result-notification [notification]="narrativeNotification" (reviewLinkClicked)="activateTab($event)"></ness-result-notification>
          <ness-result-notification [notification]="defendantsNotification" (reviewLinkClicked)="activateTab($event)"></ness-result-notification>
        </section>
      </p-tabPanel>
      <p-tabPanel *ngIf="showApprovalTab" headerStyleClass="tabpanel-header-wizard" [headerStyle]="{maxWidth:'20%'}">
        <ng-template pTemplate="header">
          <span class="round-tabs green-tab">
            <i class="far fa-thumbs-up fa-md" aria-hidden="true"></i>
          </span>
          <span class="round-tabs-label">Approval Form</span>
        </ng-template>
        <section>
          <h2>{{ approvalFormTitleText }}</h2>
          <p *ngIf="ENESS_REF_SuccessStoriesStatuses?.SuccessStoriesStatus === appConstants.Result_Status_Pending1stLineApproval && resultData?.CurrentUserIsApprover" class="fst-italic">If approved, this Result will be automatically routed to your Field Division ASACs/SAC for secondary approval</p>
          <p *ngIf="ENESS_REF_SuccessStoriesStatuses?.SuccessStoriesStatus === appConstants.Result_Status_Pending2ndLineApproval && resultData?.CurrentUserIsFDLeadership" class="fst-italic">Upon approval, this Result will be automatically routed to ATF HQ for tracking.</p>
          <div class="mb-3 w-lg-50">
            <label class="form-label" for="StatusNotes">Comments:</label>
            <div class="alert alert-info d-flex align-items-start" role="alert">
              <svg xmlns="http://www.w3.org/2000/svg" class="bi bi-info-circle-fill flex-shrink-0 mt-1 me-2" viewBox="0 0 16 16" role="img" aria-label="Information:" width="16" height="16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
              </svg>
              <div class="font-size-sm">
                If approving, comment is optional. <br /> If rejecting, comment is REQUIRED.
              </div>
            </div>
            <textarea [rows]="textAreaRows" #comments id="StatusNotes" class="form-control" formControlName="StatusNotes" maxlength="2000"></textarea>
            <div class="cross-validation-feedback" *ngIf="resultForm.get('StatusNotes').invalid">
              Please provide comments. The comments must not exceed 2000 characters.
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-active mb-2" (click)="onApprove($event)" value="approve">Approve</button>
            <button type="button" class="btn btn-active mb-2" (click)="onReject($event)" value="approve">Reject</button>
          </div>
          <div class="cross-validation-feedback" *ngIf="resultForm.invalid && !resultForm.get('StatusNotes').invalid">
            Please return to the Review page for details on missing information.
          </div>
        </section>
      </p-tabPanel>
    </p-tabView>
    <p-messages [(value)]="msgs" [enableService]="false"></p-messages>
    <div class="p-3 d-flex flex-wrap justify-content-center">
      <button *ngIf="activeTabIndex > 0" (click)="gotoPrevTab()" type="button" class="btn btn-active mx-1 my-2"><i aria-hidden="true" class="fas fa-angle-left"></i> Previous</button>
      <button *ngIf="(!showApprovalTab && activeTabIndex < 3) || (showApprovalTab && activeTabIndex < 4)" (click)="gotoNextTab()" type="button" class="btn btn-active my-2">Next <i aria-hidden="true" class="fas fa-angle-right"></i></button>
      <button *ngIf="activeTabIndex < 4" [disabled]="this.resultData.ENESS_SuccessStory?.CurrentSuccessStoryStatus?.ENESS_REF_SuccessStoriesStatuses.SuccessStoriesStatus != 'Draft'" (click)="onSubmit($event)" type="button" class="btn btn-active ms-4 my-2" value="draft">Save draft</button>
      <button *ngIf="activeTabIndex == 3" [disabled]="resultForm.invalid || isFileLimitExceeded" type="button" class="btn btn-active ms-4 my-2" (click)="onSubmit($event)" value="submit">Submit</button>
    </div>
  </form>
  <p-confirmDialog [baseZIndex]="10000" [closable]="false"></p-confirmDialog>
  <aside>
    <p-sidebar [(visible)]="showSidebar" position="right" (onShow)="defForm.editDefendant()" (onHide)="defForm.onClose()" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
      <ness-result-defendant-form #defForm [_defendant]="selectedDefendant" (onDefendantsAdded)="onDefendantAdded($event)" (closeForm)="showSidebar = false" (showPerson)="showPersonDetails($event)"></ness-result-defendant-form>
    </p-sidebar>
    <div *ngIf="showPerson">
      <p-sidebar [(visible)]="showPerson" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
        <ng-container *ngIf="viewPersonDetails">
          <ness-person-detail #personView [personDTO]="selectedPerson" [isEventPersonForm]="true" [suppressEdit]="true" (showPersonAddressDetail)="viewAddressDetails($event)"></ness-person-detail>
        </ng-container>
        <ng-container *ngIf="showPersonAddressDetails">
          <ng-container *ngIf="personAddress">
            <ness-location-detail *ngIf="showLocationView" [addressDTO]="personAddress" [hasDeletePermission]="false" [hasEditPermission]="hasPermissionToEditAddress" [personAddressType]="personAddressType" [isFromPersonDetails]="true" (editLocationLocationClicked)="editLocation($event)"></ness-location-detail>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showPersonAddressDetailForm">
          <ng-container *ngIf="personAddress">
            <ness-location-form *ngIf="showEditLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="personAddress" (associateLocation)="onLocationFormClose($event)"></ness-location-form>
          </ng-container>
        </ng-container>
        <button type="button" (click)="onClickCloseButton()" class="btn btn-active m-3">Close</button>
      </p-sidebar>
    </div>
  </aside>
</section>
